import MoneyTransfer from './MoneyTransfer';

export default MoneyTransfer;
